export const OperatorType = {
  Equals: 0,
  Greater: 1,
  Less: 2,
  GreaterEqual: 3,
  LessEqual: 4,
};
